import React, { useEffect, useMemo } from 'react'
import { useGlobalFilter, usePagination, useRowSelect, useSortBy, useTable } from 'react-table'
import matchSorter from 'match-sorter'
import PagedTable from 'core/table/components/PagedTable'
import { DateCell, EmailCell, WithLinkCell, NullableTextCell, PersonNameCell, PhoneNumberCell } from 'core/table/cells'
import Loading from 'components/Loading'
import useTasks from '../hooks/useTasks'
import * as _ from 'lodash'

const columns = [
  {
    Header: 'Recipient',
    id: 'name',
    accessor: row => row,
    Cell: props => WithLinkCell(PersonNameCell, id => `/task-persons/${id}`)(props),
  },
  {
    Header: 'Phone',
    accessor: 'phoneNumber',
    Cell: PhoneNumberCell
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: EmailCell,
  },
  {
    Header: 'Open Tasks',
    accessor: 'openTasks',
    Cell: NullableTextCell,
  },
  {
    Header: 'Completed Tasks',
    accessor: 'completedTasks',
    Cell: NullableTextCell,
  },
  {
    Header: 'Joined',
    accessor: 'createdAt',
    Cell: DateCell,

  },
  // TODO: add number of requests to api call
  // {
  //   Header: 'Requests',
  //   accessor: 'requests',
  // },
  // TODO: Add rating system
  // {
  //   Header: 'Rating',
  //   accessor: 'rating',
  // }
]

const fuzzyMatchFilter = (rows, id, filterValue) =>
  matchSorter(rows, filterValue, {
    keys: [
      'original.givenName',
      'original.familyName',
      'original.email',
      'original.phoneNumber',
    ],
  })

fuzzyMatchFilter.autoRemove = value => !value

const useMappedRecipients = ({ recipients, tasks, completedTasks }) =>
  useMemo(() => {
    const openTasksByRecipientId = _.groupBy(tasks, 'recipient.id')
    const completedTasksByRecipientId = _.groupBy(completedTasks, 'recipient.id')
    return _.map(recipients, recipient => ({
      ...recipient,
      openTasks: _.size(openTasksByRecipientId[recipient.id]),
      completedTasks: _.size(completedTasksByRecipientId[recipient.id]),
    }))
  }, [recipients, tasks, completedTasks])

export default function RecipientsTab(props) {
  const { query, recipients, loading: loadingProp } = props
  const { tasks, completedTasks, loading: tasksLoading } = useTasks()
  const loading = loadingProp || tasksLoading
  const data = useMappedRecipients({ recipients, tasks, completedTasks })
  const table = useTable({
      data,
      columns,
      getRowId: row => row.id,
      globalFilter: fuzzyMatchFilter,
      initialState: {
        globalFilter: query,
      }
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  )

  useEffect(() => table.setGlobalFilter(query), [query, table])

  return (
    <div>
      {
        loading ?
        <Loading />
        :
        <PagedTable {...table } />
      }
    </div>
  )
}
